import { render, staticRenderFns } from "./EditProductMultiple.vue?vue&type=template&id=b8040f1c"
import script from "./EditProductMultiple.vue?vue&type=script&lang=js"
export * from "./EditProductMultiple.vue?vue&type=script&lang=js"
import style0 from "./EditProductMultiple.vue?vue&type=style&index=0&id=b8040f1c&prod&lang=css"
import style1 from "../../assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports